import React, { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import '../../../assets/css/Allfilter.css';
// import PriceRange from './PriceRange';
// import PatternFilter from './PatternFilter';

function FilterAllProduct() {
  const [activeKey, setActiveKey] = useState(["0", "1", "2"]);
  const handleSelect = (key) => {
    setActiveKey(key);
  };
  return ( 
<>

<div  className='bg-gray-100 Accordions-filter'>

<Accordion activeKey={activeKey} onSelect={handleSelect}>
      <Accordion.Item eventKey="0">
        <Accordion.Header className="bg-gray-50">PATTERN</Accordion.Header>
        <Accordion.Body> 

      </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header className="bg-gray-50">Size</Accordion.Header>
        <Accordion.Body>

        <div style={{overflow: "auto",  maxHeight: "150px"}}> 

        <div className="checkbox-container">
          <input type="checkbox" id="chk1" className="checkbox-input"/>
          <label htmlFor="chk1" className="checkbox-label">Option 1</label>
        </div>


            <div className="checkbox-container">
            <label className="checkbox-label">
            <input type="checkbox" className="checkbox-input"/> 100x10
             </label>
            </div>

            <div className="checkbox-container">
            <label className="checkbox-label">
            <input type="checkbox" className="checkbox-input"/> 100x10
             </label>
            </div>
            
            <div className="checkbox-container">
            <label className="checkbox-label">
            <input type="checkbox" className="checkbox-input"/> 100x10
             </label>
            </div>

            <div className="checkbox-container">
            <label className="checkbox-label">
            <input type="checkbox" className="checkbox-input"/> 100x10
             </label>
            </div>

            <div className="checkbox-container">
            <label className="checkbox-label">
            <input type="checkbox" className="checkbox-input"/> 100x10
               </label>
            </div>

            <div className="checkbox-container">
            <label className="checkbox-label">
            <input type="checkbox" className="checkbox-input"/> 100x10
             </label>
            </div>

            <div className="checkbox-container">
            <label className="checkbox-label">
            <input type="checkbox" className="checkbox-input"/> 100x10
             </label>
            </div>

            <div className="checkbox-container">
            <label className="checkbox-label">
            <input type="checkbox" className="checkbox-input"/> 100x10
             </label>
            </div>
        </div>

        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="2">
        <Accordion.Header className="bg-gray-50">Price</Accordion.Header>
          <Accordion.Body style={{ padding: "21px 10px" }}>
          <div style={{overflow: "auto",  maxHeight: "150px"}}> 

<div className="checkbox-container">
<label className="checkbox-label">
<input type="checkbox" className="checkbox-input"/> <i className="bi bi-currency-rupee"></i>10000 - <i className="bi bi-currency-rupee"></i>20000
 </label>
</div>

<div className="checkbox-container">
<label className="checkbox-label">
<input type="checkbox" className="checkbox-input"/> <i className="bi bi-currency-rupee"></i>10000 - <i className="bi bi-currency-rupee"></i>20000
 </label>
</div>

<div className="checkbox-container">
<label className="checkbox-label">
<input type="checkbox" className="checkbox-input"/> <i className="bi bi-currency-rupee"></i>10000 - <i className="bi bi-currency-rupee"></i>20000
 </label>
</div>

<div className="checkbox-container">
<label className="checkbox-label">
<input type="checkbox" className="checkbox-input"/> <i className="bi bi-currency-rupee"></i>10000 - <i className="bi bi-currency-rupee"></i>20000
 </label>
</div>

<div className="checkbox-container">
<label className="checkbox-label">
<input type="checkbox" className="checkbox-input"/> <i className="bi bi-currency-rupee"></i>10000 - <i className="bi bi-currency-rupee"></i>20000
 </label>
</div>

<div className="checkbox-container">
<label className="checkbox-label">
<input type="checkbox" className="checkbox-input"/> <i className="bi bi-currency-rupee"></i>10000 - <i className="bi bi-currency-rupee"></i>20000
   </label>
</div>

<div className="checkbox-container">
<label className="checkbox-label">
<input type="checkbox" className="checkbox-input"/> <i className="bi bi-currency-rupee"></i>10000 - <i className="bi bi-currency-rupee"></i>20000
 </label>
</div>

<div className="checkbox-container">
<label className="checkbox-label">
<input type="checkbox" className="checkbox-input"/> <i className="bi bi-currency-rupee"></i>10000 - <i className="bi bi-currency-rupee"></i>20000
 </label>
</div>

<div className="checkbox-container">
<label className="checkbox-label">
<input type="checkbox" className="checkbox-input"/> <i className="bi bi-currency-rupee"></i>10000 - <i className="bi bi-currency-rupee"></i>20000
 </label>
</div>
</div>

</Accordion.Body>
</Accordion.Item>
</Accordion>

{/* <div className="BOX-BORDER">
           <Button className='apply-Button'> APPLY NOW </Button>
      </div> */}
</div>
    </>
  );
}

export default FilterAllProduct;